import { render, staticRenderFns } from "./FormOpeningPeriod.vue?vue&type=template&id=5ed8eb0e&"
import script from "./FormOpeningPeriod.vue?vue&type=script&lang=js&"
export * from "./FormOpeningPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports